export async function delay(ms: number): Promise<void> {
	// eslint-disable-next-line promise/avoid-new
	return new Promise((resolve) => {
		setTimeout(resolve, ms);
	});
}
